import React from 'react';
import styled, { css } from 'styled-components';

const StyledButton = styled(({ ...rest }) => <div {...rest} />)`
    text-align: center;
    padding: 8px;
    margin: 5px 0;
    font-size: 18px;
    color: #fff;
    width: 100%;
    background-color: #337ab7;
    cursor: pointer;
    border-radius: 5px;
    box-shadow: 2px 3px 8px 0 rgba(0, 0, 0, 0.3);
    -webkit-transition: all 200ms;
    -moz-transition: all 200ms;
    -ms-transition: all 200ms;
    -o-transition: all 200ms;
    transition: all 200ms;
    user-select: none;

    :hover {
        background-color: lighten(#337ab7, 5%);
        box-shadow: 5px 5px 8px 0 rgba(0, 0, 0, 0.3);
    }

    @media (max-width: 768px) {
        font-size: 16px;
    }
`;

const Button = ({ onClick, onHover, name, children, color, className }) => {
    const handleClick = (e) => {
        if (typeof onClick === 'function') {
            e.preventDefault();
            name = typeof name === 'string' ? name : false;
            return onClick(name, e);
        } else {
            console.log('No Action Bound');
        }
    };

    const handleHover = (e, enter = true) => {
        if (typeof onHover === 'function') {
            e.preventDefault();
            name = typeof name === 'string' ? name : false;
            return onHover(name, e, enter);
        } else {
            // console.log('No Action Bound');
        }
    };

    return (
        <StyledButton
            className={typeof className == 'string' && className.length > 0 ? `button ${className}` : ''}
            onClick={(e) => handleClick(e)}
            onMouseEnter={(e) => handleHover(e, true)}
            onMouseLeave={(e) => handleHover(e, false)}
        >
            {children}
        </StyledButton>
    );
};

export default Button;
